import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { reportError } from "@/(front-desk)/utils/functions"
import { handleCMS } from "@/(front-desk)/store"
import { Pattern2 } from "@/(front-desk)/utils/patterns"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"
import Transition from "@/(front-desk)/components/Transition"
import Popup from "@/(front-desk)/components/Popup"
import classNames from "classnames"
import axios from "axios"
import logo from "@/(front-desk)/assets/images/logo.png"

const PrevButton = (props) => {

    const { className, activeCategory, setActiveCategory} = props
    const competeJudges = useSelector((state) => state.CMS).competeJudges
    const activeIndex = competeJudges.indexOf(activeCategory)

    return (
        <button
            className={classNames(className, {
                'opacity-[0] pointer-events-none': competeJudges.indexOf(activeCategory) === 0
            })}
            onClick={() => {
                setActiveCategory(competeJudges[activeIndex - 1])
            }}
        ><ChevronLeftIcon className="w-14 fill-main-700" /></button>
    )
}
const NextButton = (props) => {

    const { className, activeCategory, setActiveCategory} = props
    const competeJudges = useSelector((state) => state.CMS).competeJudges
    const activeIndex = competeJudges.indexOf(activeCategory)

    return (
        <button
            className={classNames(className, {
                'opacity-[0] pointer-events-none': competeJudges.indexOf(activeCategory) === competeJudges.length - 1
            })}
            onClick={() => {
                setActiveCategory(competeJudges[activeIndex + 1])
            }}
        ><ChevronRightIcon className="w-14 fill-main-700" /></button>
    )
}

const Title = (props) => {

    const { activeCategory, setActiveCategory } = props
    const global = useSelector((state) => state.global)
    const competeJudges = useSelector((state) => state.CMS).competeJudges
    const category = competeJudges.find((category) => category.shortcut === activeCategory.shortcut)

    return (
        <div className="judges-title w-full flex-center mb-[3.5rem]">
            <div className="flex-center gap-[1.12rem] w-full md:w-auto md:min-w-[38rem] flex-col md:flex-row">
                <div className="whitespace-nowrap text-center md:text-end">
                    <div className="text-[2.25rem] text-main font-bold">
                        {global.currentCompeteYear} 競賽評審團
                    </div>
                    {/* <div className="text-[1.5rem] text-main font-bold">
                        Competition Jury
                    </div> */}
                </div>
                <div className="flex-center !justify-between w-full md:w-auto">
                    <PrevButton
                        className="block md:hidden"
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                    />
                    <Transition
                        transitionKey={category.name}
                        className="whitespace-nowrap text-center md:text-start"
                    >
                        {/* <div className="text-[1.5rem] sm:text-[2rem] text-white font-bold">
                            {category.name_en}
                        </div> */}
                        <div className="text-[3rem] text-white font-bold">
                            {category.name}
                        </div>
                    </Transition>
                    <NextButton
                        className="block md:hidden"
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                    />
                </div>
            </div>
        </div>
    )
}

const Judge = (props) => {

    const { info, onClick } = props
    const [ imgLoaded, setImgLoaded ] = useState(false)

    useEffect(() => {
        const Img = new Image()
        Img.onload = () => {
            setImgLoaded(true)
        }
        Img.src = info.info.avatar
    }, [])

    return (
        <button
            onClick={onClick}
            className={classNames('relative w-[15.5rem] text-center hover:scale-[1.05] transition', {
                'order-1': info.is_convener,
                'order-2': !info.is_convener
            })}
        >
            { info.is_convener &&
                <div className="absolute right-0 top-0 bg-black-800 w-fit flex gap-1 py-1 px-2 rounded-[0.25rem] rotate-12 z-[1]">
                    <Pattern2 className="w-6 fill-black" />
                    <div className="text-[1.125rem] text-white font-bold">召集人</div>
                </div>
            }
            <Transition transitionKey={imgLoaded}>
                <div className={classNames('flex-center w-full h-[11.25rem] bg-main-600 rounded-[0.25rem] overflow-hidden mb-5', {
                    'rounded-[1000rem]': info.is_convener
                })}>
                    { (imgLoaded || !info.info.avatar)
                        ?
                        <img
                            className={classNames({
                                'full object-cover': info.info.avatar,
                                'w-[75%]': !info.info.avatar,
                            })}
                            src={info.info.avatar ? info.info.avatar : logo.src}
                            alt={`評審${info.info.name}頭像`}
                        />
                        :
                        <div className="w-full h-full bg-black-900 animate-pulse"></div>
                    }
                </div>
            </Transition>
            <div className="text-[1.5rem] text-white font-semibold mb-2">{info.info.name}</div>
            <div className="text-black-500 font-light mb-1">{info.info.organization}</div>
            <div className="text-black-500 font-light">{info.info.title}</div>
        </button>
    )
}

export default function Judges() {

    const dispatch = useDispatch()
    const competeJudges = useSelector((state) => state.CMS).competeJudges
    const global = useSelector((state) => state.global)
    const [ activeCategory, setActiveCategory ] = useState(null)
    const [ activeJudge, setActiveJudge ] = useState(null)

    useEffect(() => {
        if (!competeJudges && global.currentCompeteYear) {
            axios.get(`/api/v1/cms/zh_hant/judges/${global.currentCompeteYear}`)
            .then((res) => {
                console.log(res.config.url, res.data)
                dispatch(handleCMS.actions.setCompeteJudges(res.data.body.filter(
                    (category) => !category.is_enterprise && category.judges.length > 0
                )))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                dispatch(handleCMS.actions.setCompeteJudges(false))
                reportError(err)
            })
        }
    }, [global.currentCompeteYear])

    useEffect(() => {
       if (competeJudges) {
            setActiveCategory(competeJudges[0])
       }
    }, [competeJudges])

    if (competeJudges && activeCategory) return (
        <>
        <div className="flex-center flex-col">
            <Title
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
            />
            <div className="w-full flex gap-4">
                <PrevButton
                    className="h-fit mt-[calc(15.5rem/2)] hidden md:block"
                    activeCategory={activeCategory}
                    setActiveCategory={setActiveCategory}
                />
                <Transition
                    transitionKey={activeCategory.shortcut}
                    className="w-full"
                >
                    { competeJudges.map((category) => (
                        <div
                            key={`category-${category.shortcut}`}
                            className={classNames('flex-center flex-wrap gap-10', {
                                '!hidden': category.shortcut !== activeCategory.shortcut
                            })}
                        >
                            { category.judges.map((judge, judgeIndex) => (
                                <Judge
                                    key={`${category.shortcut}-${judgeIndex}`}
                                    info={judge}
                                    onClick={() => {
                                        setActiveJudge({
                                            category: category,
                                            judge: judge
                                        })
                                    }}
                                />
                            ))}
                        </div>
                    ))}
                </Transition>
                <NextButton
                    className="h-fit mt-[calc(15.5rem/2)] hidden md:block"
                    activeCategory={activeCategory}
                    setActiveCategory={setActiveCategory}
                />
            </div>
        </div>

        { activeJudge &&
            <Popup
                contentClassName="!p-0 !max-w-[40rem] !w-[90%] !h-fit !bg-black-900 !rounded-[1.25rem] overflow-hidden"
                onClose={() => {setActiveJudge(null)}}
            >
                <div className="absolute -bottom-1 w-[99.9%] h-1/2 bg-main rounded-[1.25rem] z-[-1]"></div>
                <img
                    className="w-full h-[20rem] object-cover"
                    src={activeJudge.judge.info.avatar}
                    alt={`評審${activeJudge.judge.info.name}頭像`}
                />
                <div className="p-[2.5rem]">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="text-[1.5rem] text-main-600 font-semibold">
                            {activeJudge.category.year} {activeJudge.category.name}評審
                        </div>
                        <div className={classNames('text-[1.125rem] text-white font-bold px-2 py-1 bg-main-700 rounded-[0.25rem]', {
                            'hidden': !activeJudge.judge.is_convener
                        })}>召集人</div>
                    </div>
                    <div className="text-[2.5rem] text-white font-bold mb-1">
                        {activeJudge.judge.info.name}
                    </div>
                    <div className="text-white font-light whitespace-pre-wrap">
                        {activeJudge.judge.info.bio}
                    </div>
                </div>
            </Popup>
        }
        </>
    )
}
